import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # LoadBal
 *
 * LoadBal을 설명하세요.
 */
export const LoadBal = types
  .model('LoadBal')
  // --------------------------------------------------------------------------
  .props({
    loadBalSid: types.identifierNumber,
    loadBalNm: types.optional(types.string, ''), // 로드밸런서명
    spplyNm: types.maybeNull(types.string), // 공급자
    loadBalId: types.maybeNull(types.string), // ID
    networkInfo: types.maybeNull(types.string), // 네트워크
    applyObj: types.maybeNull(types.string), // 적용 대상

    useYn: types.optional(types.string, 'Y'),
    delYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model loadBal --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: ILoadBal }) => {
      const newProps = { ...self, ...props } as ILoadBal;
      (Object.keys(newProps) as TLoadBalKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TLoadBal = Instance<typeof LoadBal>;
type TLoadBalSnapshot = SnapshotOut<typeof LoadBal>;

export interface ILoadBal extends TLoadBal {}
export type TLoadBalKeys = keyof TLoadBalSnapshot & string;
export interface ILoadBalSnapshot extends TLoadBalSnapshot {}
export const createLoadBal = () => types.optional(LoadBal, {} as TLoadBal);
